<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { storeToRefs } from "pinia";
import PaymentBoxes from "#/semantics/paymentBoxes/PaymentBoxes.vue";
import { useCartStore } from "#/store/cart";
import { useMainStore } from "#/store/main";
import ButtonDefault from "#/ui/buttons/default/ButtonDefault.vue";
import AnimNum from "#/ui/recountNumber/RecountNumber.vue";

const { t } = useTranslation();
const cartStore = useCartStore();
const storeMain = useMainStore();

const props = defineProps<{
	configPage: {
		kiosk_menu: boolean;
		qr_menu: boolean;
	};
	comment: string;
	cartItems: any[];
	orderId?: string | null;
	signal?: AbortSignal;
}>();

const { totalPrice_lib, countBonus } = storeToRefs(storeMain);

const emit = defineEmits<{
	selectPayment: [providerId: string];
	close: [];
}>();

const onSelectPayment = (providerId: string) => {
	emit("selectPayment", providerId);
};

const closeChangePayment = () => {
	emit("close");
};
</script>

<template>
	<div class="wrapper_cart_payment" v-if="cartStore.providerTypes.length > 1">
		<h2>{{ t(`cart-payment.title`) }}</h2>
		<p class="description_payment">{{ t(`cart-payment.description`) }}</p>
		<div v-for="(provider, index) in cartStore.providerTypes" :key="index">
			<PaymentBoxes
				:provider="provider"
				:config-page="props.configPage"
				:comment="props.comment"
				:cart-items="props.cartItems"
				:order-id="props.orderId"
				:signal="props.signal"
				@select="onSelectPayment"
			/>
		</div>
		<div class="wrapper_paid">
			<p class="to_be_paid">
				{{ t(`cart-payment.to-be-paid`) }}
				<AnimNum :price="totalPrice_lib - countBonus" :symbol="storeMain.config_lib.currency_symbol" />
			</p>
			<ButtonDefault :textButtonDefault="t(`cart-payment.back`)" :onClick="closeChangePayment" class="btn_payment" />
		</div>
	</div>
</template>

<style lang="scss" scoped>
  @use './cartPayment.scss';
</style>
